import axios from "axios";
import { API_BASE_URL } from "../config";
import _ from "lodash";
import { BehaviorSubject, Observable } from 'rxjs'

let UtilsService = {};

UtilsService.constants = false;

UtilsService.getConstant = (hard = false) => {
    return new Promise(async (resolve, reject) => {

        if (UtilsService.constants && !hard) {
            return resolve(UtilsService.constants);
        } else {
            const url = `${API_BASE_URL}/admin/constants`;

            axios({ url }).then(
                (e) => {
                    if (_.get(e, "data.success", false)) {
                        UtilsService.constants = _.get(e, "data.data");
                        resolve(UtilsService.constants);
                    } else {
                        UtilsService.constants = false;
                        resolve(false);
                    }
                }, (er) => {
                    UtilsService.constants = false;
                    resolve(false);
                }
            );
        }

    });
}

UtilsService.processingSubject = new BehaviorSubject(false);
UtilsService.processing = UtilsService.processingSubject.asObservable();
UtilsService.processingValue = false;

UtilsService.changeProcessing = (status) => {
    if (UtilsService.processingSubject.getValue() !== status) {
        UtilsService.processingValue = status;
        UtilsService.processingSubject.next(status);
    }
}


/**
 * 
 * @param {string} url 
 * @param {Object} queryParams 
 * @returns 
 */
UtilsService.addQueryParams = (url, queryParams) => {
    queryParams = _.map(queryParams, (value, key) => {
        return `${key}=${value}`;
    })
    queryParams = Object.values(queryParams).join("&")

    return `${url}?${queryParams}`;
}

UtilsService.dashboard = async (queryParams = {}) => {
    const url = UtilsService.addQueryParams(`${API_BASE_URL}/admin/dashboard`, queryParams);
    const res = await axios({ url });
    return res;
}

/**
 * 
 * @param {Number} sum_assured 
 * @param {{label: String, benefit_includes: Boolean, premium_rate: Number}[]} benefits 
 * @returns 
 */
UtilsService.getDynamicPlanPremium = (sum_assured, benefits) => {
    let monthly_premium = 0;

    if (benefits && benefits.length > 0) {
        benefits.forEach(benefit => {
            if (benefit.benefit_includes && benefit.premium_rate) {
                let premium = (benefit.premium_rate / 1000) * sum_assured;
                monthly_premium = monthly_premium + premium;
            }
        })
    }

    return {
        monthly: monthly_premium,
        quarterly: (monthly_premium * 3),
        half_yearly: (monthly_premium * 6),
        yearly: (monthly_premium * 12)
    }
}

// UtilsService.getPlanType = (plan_type) => plan_type ? plan_type : "simple"
UtilsService.getPlanType = (plan_type) => plan_type == "simple" ? "Simple" : (plan_type == "dynamic" ? "Dynamic" : "")

UtilsService.addMonthlyPremium = (plans) => {
    if (plans && Array.isArray(plans)) {
        plans = plans.map(plan => {
            plan.monthly_fee = (plan.pricing && Array.isArray(plan.pricing)) ? plan.pricing.find(price => (price.billing_period === 'monthly')) : undefined;
            if (plan.monthly_fee) {
                plan.monthly_fee = plan.monthly_fee.amount;
            }
            return plan;
        })
    }
    return plans;
}

UtilsService.addMonthlyPremiumSingle = (plan) => {
    plan.monthly_fee = (plan.pricing && Array.isArray(plan.pricing)) ? plan.pricing.find(price => (price.billing_period === 'monthly')) : undefined;
    if (plan.monthly_fee) {
        plan.monthly_fee = plan.monthly_fee.amount;
    }
    return plan;
}



export default UtilsService;